import React, { FC, useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { TimerText } from './OTPInputStyle';
import JoinSkipButton from '../join/JoinSkipButton';
import { StepText, resendPasscodeLinkStyle, resendPasscodeText } from '../../screens/LoginStyle';
import { RootState } from '../../store';
import { DEFAULT_TIMER } from '../../config/constants';
import { resetOtpState } from '../../actions/authActions';

const OTPTimer: FC<any> = props => {
  const { resendPasscodeClick, resendOTPTitle, isLastAttempt, type, onResetOTP } = props;
  const { isOtpSent } = useSelector((state: RootState) => state.auth);
  const [otpTimer, setOtpTimer] = useState(0);
  const [lastAttemptTimer, setLastAttemptTimer] = useState(0);

  const dispatch = useDispatch();

  useMemo(() => {
    if (isLastAttempt) {
      //set last attampt timer to 60 min
      setLastAttemptTimer(3600);
    }
  }, [isLastAttempt]);

  useMemo(() => {
    if (onResetOTP) {
      //reset otp timer
      setOtpTimer(isLastAttempt ? 3600 : DEFAULT_TIMER);
    }
  }, [onResetOTP]);

  useEffect(() => {
    if (lastAttemptTimer > 0) {
      const interval = setInterval(() => {
        setLastAttemptTimer(prev => prev - 1);
      }, 1000);

      return () => {
        if (interval) clearInterval(interval);
      };
    }
  }, [lastAttemptTimer]);

  useMemo(() => {
    if (otpTimer === 0 && isOtpSent) {
      setOtpTimer(DEFAULT_TIMER);
    }
  }, [isOtpSent]);

  useEffect(() => {
    if (isOtpSent && otpTimer > 0) {
      const interval = setInterval(() => {
        setOtpTimer(prev => {
          if (prev <= 1) {
            // Timer is about to reach 0, reset the OTP state
            dispatch(resetOtpState());
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => {
        if (interval) clearInterval(interval);
      };
    }
  }, [isOtpSent, otpTimer, dispatch]);

  const handleResendPasscode = () => {
    //call resend passcode api
    // dispatch(resetOtpState());
    resendPasscodeClick();
  };

  // Format timer to mm:ss
  const formatTime = (time: number) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;

    return `${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  const renderResendPasscode = () => {
    if (type === 'phone') {
      return (
        <div style={{ display: 'flex', marginTop: 15 }}>
          <span style={resendPasscodeText}>Didn’t receive the code?</span>
          <JoinSkipButton
            label={resendOTPTitle || 'Resend Passcode'}
            customStyle={{ ...resendPasscodeLinkStyle, fontWeight: 600, color: '#2B8FD7' }}
            onClick={handleResendPasscode}
          />
        </div>
      );
    } else {
      return (
        <JoinSkipButton
          label={resendOTPTitle || 'Resend Passcode'}
          customWrapperStyle={{ marginTop: '15px' }}
          customStyle={resendPasscodeLinkStyle}
          onClick={handleResendPasscode}
        />
      );
    }
  };

  return (
    <>
      {isLastAttempt ? (
        <>
          <StepText style={{ paddingTop: 15, fontSize: 15, fontWeight: 600 }}>
            The max attempts have been reached.
          </StepText>
          <StepText
            style={{ paddingTop: 3, fontSize: 15 }}
          >{`Please try again in ${formatTime(lastAttemptTimer)}`}</StepText>
        </>
      ) : isOtpSent && otpTimer > 0 ? (
        <TimerText>{`Your code should arrive in: ${formatTime(otpTimer)}`}</TimerText>
      ) : (
        renderResendPasscode()
      )}
    </>
  );
};

export default OTPTimer;
